import { render, staticRenderFns } from "./TariffBenefitList.vue?vue&type=template&id=6affa963&"
import script from "./TariffBenefitList.vue?vue&type=script&lang=js&"
export * from "./TariffBenefitList.vue?vue&type=script&lang=js&"
import style0 from "./TariffBenefitList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TariffBenefitList.vue"
export default component.exports